@if (userId) {
@if (embeddedLoading) {
<p
  role="status"
  i18n="@@globalUserLoading"
>Nutzer wird geladen …</p>
} @else if (embeddedError) {
<p role="alert">{{ embeddedError }}</p>
<button
  pButton
  type="button"
  (click)="loadEmbeddedUser()"
  i18n="@@globalRetry"
>Erneut versuchen</button>
} @else if (embeddedUser) {
<fieldset
  [disabled]="embeddedSaving"
  class="border-0 p-0 m-0"
>
  <app-form
    #embeddedForm
    [data]="embeddedUser"
    [formFields]="[
          { fieldName: 'email', type: 'text', required: true },
          { fieldName: 'name', type: 'text', required: true },
          { fieldName: 'reflactadmin', type: 'switch' },
          { fieldName: 'mandantSelection', type: 'template', options: { template: globalUserMandantConfig, customData: {mandants: mandants} } }
        ]"
    [translatedLabels]="translatedLabels"
    [hideDeleteButton]="true"
    [showActions]="false"
    (submit)="saveEmbeddedUser($event)"
  ></app-form>
</fieldset>
<div class="d-flex justify-content-end mt-3">
  <button
    pButton
    type="button"
    [loading]="embeddedSaving"
    [disabled]="embeddedSaving || !embeddedForm?.form?.valid || !hasEmbeddedChanges()"
    (click)="embeddedForm?.onSubmit()"
    i18n="@@save"
  >Speichern</button>
</div>
}
} @else {
<app-user-management
  [columns]="[
    {fieldName: 'mandantCount', label: 'Mandanten', template:mandantCountTpl, headerTemplate:mandantCountHeaderTpl},
    {fieldName: 'email', label: 'Email', template: emailTpl},
    {fieldName: 'name', label: 'Name'},
    {fieldName: 'reflactadmin', label: 'Reflact Admin', template:reflactAdmin},
    {fieldName: 'lastSignInAt', label: 'Status', template:signInStatus}
  ]"
  [formFields]="[
    { fieldName: 'email', type: 'text', required: true },
    { fieldName: 'name', type: 'text', required: true },
    { fieldName: 'reflactadmin', type: 'switch'},
    { fieldName: 'mandantSelection', type: 'template', options: { template: globalUserMandantConfig, customData: {mandants: this.mandants} }}
  ]"
  [formFieldsCreator]="[
    { fieldName: 'email', type: 'text', required: true },
    { fieldName: 'name', type: 'text', required: true },
    { fieldName: 'reflactadmin', type: 'switch'},
    { fieldName: 'permissions', label: 'Mandanten-Admin', type: 'template', options: { template: mandantAdminTpl } },
    { fieldName: 'mandant', type: 'select', required: true, options: {selectValues: this.mandants, bindValue: '_id', bindLabel: 'name'} }
  ]"
  [formFieldCreatorData]="{email: '', name: '', reflactAdmin: false, permissions: [], mandant: null}"
  [translatedLabels]="translatedLabels"
  [service]="frontendService"
  [saveUser]="performUpdateUser"
  [creating]="creating"
  (createUserEvent)="createUser($event)"
  (selectUserEvent)="onSelectGlobalUser($event)"
  i18n-newUserText="@@newUser"
  newUserText="Neuer Nutzer"
  [deleteButton]="false"
></app-user-management>
}

<ng-template
  #emailTpl
  let-data="data"
>{{ data.email }}<app-test-user-badge [email]="data.email"></app-test-user-badge></ng-template>

<ng-template #mandantCountHeaderTpl>
  <i
    class="ri-building-line"
    pTooltip="Mandanten"
    i18n-pTooltip="@@globalUserAdminMandantsColumn"
    tooltipPosition="top"
  ></i>
</ng-template>

<ng-template
  #mandantCountTpl
  let-data="data"
>
  <span
    [pTooltip]="data.mandantNames?.length ? data.mandantNames.join(', ') : globalUserNoMandants"
    tooltipPosition="top"
  >{{ data.mandantCount }}</span>
</ng-template>

<ng-template
  #reflactAdmin
  let-data="data"
>
  <i
    class="ri-close-line text-danger"
    *ngIf="!data.reflactadmin"
  ></i>
  <i
    class="ri-check-line text-success"
    *ngIf="data.reflactadmin"
  ></i>
</ng-template>

<ng-template
  #signInStatus
  let-data="data"
>
  <span
    class="badge bg-warning"
    *ngIf="!data.lastSignInAt"
    i18n="@@globalUserAdminNeverSignedIn"
  >Noch nicht angemeldet</span>
  <span
    class="badge bg-success"
    *ngIf="data.lastSignInAt"
    i18n="@@globalUserAdminSignedIn"
  >Angemeldet</span>
</ng-template>

<ng-template
  #mandantAdminTpl
  let-data="data"
>
  <div class="form-check form-switch">
    <input
      type="checkbox"
      role="switch"
      class="form-check-input"
      id="createUserMandantAdminSwitch"
      [checked]="isMandantAdmin(data)"
      (change)="toggleMandantAdmin(data, $any($event.target).checked)"
    >
    <label
      class="form-check-label"
      for="createUserMandantAdminSwitch"
      i18n="@@userAdminMandantAdminLabel"
    >Mandanten-Admin dieser Organisation</label>
  </div>
</ng-template>

<ng-template
  #globalUserMandantConfig
  let-data="data"
>
  <div>
    <h5 i18n="@@addToMandant">Zu Mandant hinzufügen</h5>

    <button
      pButton
      type="button"
      [outlined]="true"
      [disabled]="!data.mandants"
      class="mb-3"
      (click)="mandantMenu.toggle($event)"
      title="Mandant hinzufügen"
      i18n-title="@@globalUserAddMandantTooltip"
    ><i class="ri-add-line"></i></button>
    <p-menu
      #mandantMenu
      [popup]="true"
      [model]="getMandantMenuItems(data)"
      appendTo="body"
    ></p-menu>

    <div
      class="my-3"
      *ngIf="data.mandants; else mandantsLoadingTpl"
    >
      <p-accordion [multiple]="true">
        <ng-container *ngFor="let mandant of data.mandants">
          <p-accordion-panel
            *ngIf="this.mandantService.findMandant(mandant)"
            [value]="mandant"
          >
            <p-accordion-header>
              <div class="d-flex justify-content-between align-items-center w-100 me-2">
                <span class="d-flex align-items-center gap-2">
                  <span
                    class="mandant-admin-badge"
                    *ngIf="isMandantAdminInMandant(data, mandant)"
                    title="Mandanten-Admin"
                    i18n-title="@@mandantAdminUserIsMandantAdminTooltip"
                  ><i class="ri-vip-crown-2-fill"></i></span>
                  <b>{{this.mandantService.findMandant(mandant)!.name}}</b>
                  <span
                    *ngIf="this.mandantService.findMandant(mandant)!.internal"
                    class="mandant-internal-badge"
                  >{{ internalLabel }}</span>
                </span>
                <button
                  pButton
                  severity="danger"
                  [outlined]="true"
                  type="button"
                  (click)="$event.stopPropagation(); this.removeUserFromMandant(data, mandant)"
                  i18n="@@globalUserRemove"
                >Entfernen</button>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <ng-container *ngFor="let detail of data.mandantDetails">
                <ng-container *ngIf="detail._id === mandant">
                  <div class="form-check form-switch mb-2">
                    <input
                      type="checkbox"
                      role="switch"
                      class="form-check-input"
                      [id]="'mandantAdminSwitch-' + detail._id"
                      [checked]="isMandantAdmin(detail)"
                      (change)="toggleMandantAdmin(detail, $any($event.target).checked)"
                    >
                    <label
                      class="form-check-label"
                      [for]="'mandantAdminSwitch-' + detail._id"
                      i18n="@@globalUserAdminPermissions"
                    >Mandanten-Admin dieser Organisation</label>
                  </div>

                  <label
                    class="form-label mb-1"
                    i18n="@@globalUserAdminToolsAndLinks"
                  >Tool &amp; Link - Zuweisung</label>
                  <p-picklist
                    [source]="getTilesPicklistSource(mandant, detail)"
                    [target]="getTilesPicklistTarget(mandant, detail)"
                    targetOptionDisabled="readonlyAssignment"
                    (onMoveToTarget)="syncTilesPicklistValue(mandant, detail)"
                    (onMoveToSource)="syncTilesPicklistValue(mandant, detail)"
                    (onMoveAllToTarget)="syncTilesPicklistValue(mandant, detail)"
                    (onMoveAllToSource)="syncTilesPicklistValue(mandant, detail)"
                    dataKey="_id"
                    [showSourceControls]="false"
                    [showTargetControls]="false"
                    [responsive]="true"
                    class="d-block"
                  >
                    <ng-template
                      #item
                      let-tile
                    >
                      <div
                        class="tile-select-option"
                        [class.opacity-50]="tile.readonlyAssignment"
                      >
                        <span
                          class="tile-select-option__icon"
                          [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
                        >
                          <app-tile-icon [tile]="tile"></app-tile-icon>
                        </span>
                        <span class="tile-select-option__name">{{ tile.name }}</span>
                        @if (tile.readonlyAssignment) {
                        <small i18n="@@userTileSharedReadonly">Für alle freigegeben</small>
                        }
                      </div>
                    </ng-template>
                  </p-picklist>

                  <ng-container *ngFor="let tile of getPermissionTilesForMandant(mandant)">
                    <div
                      class="tile-custom-permissions-row mb-2"
                      *ngIf="tile.customPermissions?.length"
                    >
                      <span class="form-label d-block mb-1">{{tile.name}}</span>
                      <div
                        class="form-check"
                        *ngFor="let cp of tile.customPermissions"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [id]="'tilePermission-' + detail._id + '-' + tile._id + '-' + cp.key"
                          [checked]="hasTilePermission(detail, tile._id, cp.key)"
                          (change)="toggleTilePermission(detail, tile._id, cp.key)"
                        />
                        <label
                          class="form-check-label"
                          [for]="'tilePermission-' + detail._id + '-' + tile._id + '-' + cp.key"
                        >{{cp.label}}</label>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </p-accordion-content>
          </p-accordion-panel>
        </ng-container>
      </p-accordion>
    </div>
    <ng-template #mandantsLoadingTpl>
      <div class="d-flex align-items-center gap-2 text-muted my-3">
        <i class="ri-loader-4-line ri-spin"></i>
        <span i18n="@@globalUserMandantsLoading">Mandanten werden geladen …</span>
      </div>
    </ng-template>
  </div>
</ng-template>